import gql from 'graphql-tag';
const LAUNCH_GEOTARGET_OBSERVATIONS = gql`
  mutation launchObservationJobGeotarget($id: ID!) {
    launchObservationJobGeotarget(id: $id)
  }
`;

export default LAUNCH_GEOTARGET_OBSERVATIONS;
